import React from "react";
import { Link, useParams } from "react-router-dom";
import { DagaBlogCardVerticle } from "./DagaBlogCard";
import { useGetSingleBlogQuery } from "../../../redux/slices/blogSlice";
import { marked } from "marked";

const DagaBlogPage = () => {
  const name = useParams().name;
  console.log(name);
  const {
    data: blogData,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetSingleBlogQuery(name);
  console.log(isSuccess, isLoading, isError, error);
  console.log(isSuccess && blogData);
  console.log(blogData?.data);
  const blogArray = isSuccess && blogData ? Object.values(blogData) : [];
  console.log(blogArray);
  const convertMarkdownToHtml = (markdown) => {
    return marked(markdown);
  };
  return (
    <div className="pb-8 bg-text_light_2">
      <div className="max-w-screen-lg mx-auto">
        {blogArray?.map((item, index) => (
          <main className="mt-10">
            <div className="mb-4 md:mb-0 w-full mx-auto relative">
              <div className="px-4 lg:px-0">
                <h2 className="text-4xl font-semibold text-gray-800 leading-tight">
                  {item?.title}
                </h2>
                <p
                  href="#"
                  className="py-2 text-green-700 inline-flex items-center justify-center mb-2"
                >
                  {item?.blog_category}
                </p>
              </div>

              <img
                src={`https://demoerp.plushvie.in${item?.meta_image}`}
                className="aspect-[3/2] w-full object-contain lg:rounded"
                alt="Blog Poster"
              />
            </div>

            <div className="flex flex-col lg:flex-row lg:space-x-12">
              <div className="px-4 lg:px-0 mt-12 text-gray-700 text-lg leading-relaxed w-full lg:w-3/4 text-justify">
                <div
                  className="markdown-content"
                  dangerouslySetInnerHTML={{
                    __html: convertMarkdownToHtml(item?.content_md),
                  }}
                />{" "}
              </div>
              <DagaBlogCardVerticle />
            </div>
          </main>
        ))}
      </div>
    </div>
  );
};

export default DagaBlogPage;
